import { useSelector } from 'react-redux';

import { selectIsShopEnabled } from 'app/pages/order/redux/order-selector';
import { NavigationService } from 'app/services/navigation-service';
import { RequestType } from 'app/pages/order/redux/model/order-request';
import { RequestToExecute } from 'app/components/protected-content-without-completed-requests';
import { fetchShopStatusActionCreator } from 'app/pages/order/redux/action-creators/fetch-shop-status-action-creator';

export const useShopStatusRequest = (): RequestToExecute => {
    const isShopEnabled = useSelector(selectIsShopEnabled);

    return {
        requestType: RequestType.GET_SHOP_STATUS,
        actionToDispatch: fetchShopStatusActionCreator(),
        redirectTo: () => {
            if (!isShopEnabled) {
                return NavigationService.PRODUCT_NOT_AVAILABLE;
            }
            return undefined;
        },
    };
};
